class CustomProductTabs extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.defaultTab = this.dataset.defaultTab;
    this.tabButtons = this.querySelectorAll('.product-tabs__button');
    this.tabPanels = this.querySelectorAll('.product-tabs__panel');
    this.activeTab = null;
    
    this.init();
  }

  init() {
    console.log('ProductTabs initialized', {
      sectionId: this.sectionId,
      defaultTab: this.defaultTab,
      tabButtons: this.tabButtons.length,
      tabPanels: this.tabPanels.length
    });
    this.bindEvents();
    this.initializeDefaultTab();
  }

  initializeDefaultTab() {
    // Find the default tab button
    let defaultButton = null;
    
    // First, try to find an already active button
    defaultButton = this.querySelector('.product-tabs__button.active');
    
    if (!defaultButton && this.defaultTab) {
      // Try to find by data-tab attribute
      defaultButton = this.querySelector(`[data-tab="description"]`);
    }
    
    if (!defaultButton) {
      // Fallback to first button
      defaultButton = this.tabButtons[0];
    }
    
    if (defaultButton) {
      this.setActiveTab(defaultButton);
    } else {
      console.warn('No tab buttons found for ProductTabs');
    }
  }

  bindEvents() {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.setActiveTab(button);
      });
    });
  }

  setActiveTab(activeButton) {
    // Remove active state from all buttons and panels
    this.tabButtons.forEach(button => {
      button.setAttribute('aria-selected', 'false');
      button.classList.remove('active');
    });
    
    this.tabPanels.forEach(panel => {
      panel.style.display = 'none';
      panel.classList.remove('active');
    });

    // Set active state on clicked button
    activeButton.setAttribute('aria-selected', 'true');
    activeButton.classList.add('active');
    
    // Show corresponding panel
    const tabId = activeButton.dataset.tab;
    const activePanel = this.querySelector(`[data-tab-content="${tabId}"]`);
    
    if (activePanel) {
      activePanel.style.display = 'block';
      activePanel.classList.add('active');
    }
    
    this.activeTab = tabId;
  }
}

customElements.define('custom-product-tabs', CustomProductTabs);
